module.exports = __webpack_public_path__ + "img/project2_medium@2x.322bf874.jpg";